import { onClientReadingPanePositionChange } from 'owa-mail-layout';
import { orchestrator } from 'satcheljs';
import { listViewStore } from 'owa-mail-list-store';

/**
 * Clears the vlv-rowInfo from list view store upon reading pane position change
 */
export default orchestrator(onClientReadingPanePositionChange, actionMessage => {
    listViewStore.rowInfoForVLV.clear();
});
